import { useLocation } from 'react-router-dom';

export const useDeepLink = () => {
  const searchParams = new URLSearchParams(useLocation().search);

  return {
    isDeepLink: Boolean(searchParams.get('r')),
    isDraft: Boolean(searchParams.get('draft')),
  };
};
